// Imports => React
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const _CLASSES = {
  MAIN: 'ac-project-introduction',
  LOADED: 'ac-project-introduction--loaded',
  CONTAINER: {
    MAIN: 'ac-project-introduction__container',
  },
  BACKGROUND: {
    MAIN: 'ac-project-introduction__background',
    WRAP: 'ac-project-introduction__background-wrp',
  },
  OVERLAY: {
    MAIN: 'ac-project-introduction__overlay',
  },
  INNER: {
    MAIN: 'ac-project-introduction__inner',
    TITLE: 'ac-project-introduction__title',
    SUBTITLE: 'ac-project-introduction__subtitle',
    BUTTON: 'ac-project-introduction__memorandam-button',
  },
};

class AcProjectIntroductionController extends React.Component {
  constructor(props) {
    super(props);

    this._timer = null;
    this._delay = props.routing.history.action === 'PUSH' ? 1000 : 0;

    this.el = false;
    this.background = {
      el: false,
      wrp: false,
    };

    this.state = {
      loaded: false,
      background: {
        styles: '',
      },
    };
  }

  componentDidMount() {
    clearTimeout(this._timer);
  }

  componentWillUnmount() {
    clearTimeout(this._timer);
  }

  handleBackButtonCallback = (event, el) => {
    const { backButton } = this.props;
    const { goBack } = this.props.routing;

    if (backButton && goBack) goBack();
  };

  handleBlazyCallback = state => {
    this._timer = setTimeout(() => {
      this.setState({ loaded: state });
    }, this._delay);
  };

  getSubTitleClassNames = () => {
    return clsx(_CLASSES.INNER.SUBTITLE);
  };

  getTitleClassNames = () => {
    return clsx(_CLASSES.INNER.TITLE);
  };

  getButtonClassNames = () => {
    return clsx(_CLASSES.INNER.BUTTON);
  };

  getInnerClassNames = () => {
    return clsx(_CLASSES.INNER.MAIN);
  };

  getOverlayClassNames = () => {
    return clsx(_CLASSES.OVERLAY.MAIN);
  };

  getBackgroundClassNames = () => {
    return clsx(_CLASSES.BACKGROUND.MAIN);
  };

  getBackgroundWrapClassNames = () => {
    return clsx(_CLASSES.BACKGROUND.WRAP);
  };

  getContainerClassNames = () => {
    return clsx(_CLASSES.CONTAINER.MAIN);
  };

  getStyleClassNames = () => {
    const { loaded } = this.state;
    return clsx(_CLASSES.MAIN, loaded && _CLASSES.LOADED);
  };
}

AcProjectIntroductionController.propTypes = {
  image: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  backButton: PropTypes.bool,
};

AcProjectIntroductionController.defaultProps = {
  image: '',
  title: '',
  backButton: true,
};

export default AcProjectIntroductionController;
